import { connect } from "react-redux";
import { getSPParticipantsListRequest } from "store/actions/sp.actions";
import { getParticipantsList } from "store/selector/sp.selector";
import { getSpSetting } from "store/selector/sp.selector";

import ParticipantExpiringDocuments from "./ParticipantExpiringDocReports";

const mapDispatchToProps = {
  getParticipantList: getSPParticipantsListRequest,
};

const mapStateToProps = (state) => {
  const spParticipants = getParticipantsList(state);
  const settings = getSpSetting(state);
  return {
    spParticipants,
    settings,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ParticipantExpiringDocuments);
